import React from 'react';
import { Button, Badge, Dropdown, MenuItem } from 'react-bootstrap';
import { SortableElement } from 'react-sortable-hoc';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Tooltip from '../../../../../../components/Tooltip';
import FormSwitch from '../../../../../../components/FormSwitch';
import SortHandle from './Handle';

const SortRow = ({ access, item, onChangeVisibility, handleChangeAllow, onEdit }) => {
  const exchange = !isEmpty(item.exchange) ? item.exchange : false;
  const max = parseInt(item?.max, 10) > 0 ? item?.max : '∞';

  return (
    <tr
      className={classNames('payments-list__item', {
        grey: !item.visibility,
      })}
    >
      {access?.payments_sort ? (
        <td className="item__handle">
          <SortHandle />
        </td>
      ) : null}
      <td className="item__method">
        <span>{item.method_name}</span>
        {' '}
        {exchange ? (
          <Tooltip placement="top" tooltipClass="tooltip__top" text={`Conversion from ${exchange?.from_currency}`}>
            <Badge>{exchange?.from_currency}</Badge>
          </Tooltip>
        ) : null}
      </td>
      <td className="item__name">
        <span>{item.title}</span>
      </td>
      <td className="item__min">
        <span>{item?.details?.manual ? '-' : item.min}</span>
      </td>
      <td className="item__max">
        <span>{item?.details?.manual ? '-' : max}</span>
      </td>
      <td className="item__new">
        <span>{item.new_users ? 'Allowed' : 'Not allowed'}</span>
      </td>
      {access?.payments_toggle_visibility ? (
        <td className="item__visibility">
          <FormSwitch checked={!!item.visibility} onChange={(e) => onChangeVisibility(e, item)} />
        </td>
      ) : null}
      <td className="item__actions p-r">
        {access?.payments_toggle_possibility_of_use ? (
          <div className="pull-right">
            <Dropdown id="dropdown-actions-payments" pullRight onSelect={(key) => handleChangeAllow(key, item)}>
              <Button bsRole="toggle" bsSize="xsmall" className="item__actions-users" style={{ border: 'none', marginLeft: '8px' }}>
                <span className="fa fa-ellipsis-h" />
              </Button>
              <Dropdown.Menu>
                <MenuItem eventKey="allow">Allow for all users</MenuItem>
                <MenuItem eventKey="disallow">Disallow for all users</MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        ) : null}
        {access?.payments_edit ? (
          <Button bsSize="xsmall" className="pull-right" onClick={() => onEdit(item)}>
            Edit
          </Button>
        ) : null}
      </td>
    </tr>
  );
};

SortRow.propTypes = {
  access: PropTypes.object,
  item: PropTypes.object,
  onChangeVisibility: PropTypes.func,
  handleChangeAllow: PropTypes.func,
  onEdit: PropTypes.func,
};

export default SortableElement(SortRow);
